<button
  mat-fab
  color="primary"
  (click)="openOrganiser()"
  [matTooltip]="'graphs.organise_graphs' | translate"
>
  <mat-icon>bar_chart</mat-icon>
</button>
